import React, { useEffect } from "react";
import styles from "./style.module.css";
import { useDispatch, useSelector } from "react-redux";
import { setTheme } from "../../Store/Slices/languageSelectorSlice";

function ThemeToggler() {
  const dispatch = useDispatch();
  const theme = useSelector((state) => state.theme.theme);
  // console.log("theme from store",theme);

  const toggleButton = (value) => {
    // console.log("Toggle", value);
    dispatch(setTheme(value));
    themeChecker(value);
  };

  const themeChecker = (flag) => {
    if (flag === true) {
      document.documentElement.setAttribute("data", "theme-light");
    } else {
      document.documentElement.setAttribute("data", "theme-dark");
    }

    localStorage.setItem("theme", flag);
  };
  useEffect(() => {
    themeChecker(theme);
  }, [theme]);

  return (
    <>
      <button
        onClick={()=>toggleButton(!theme)}
        className={`w-10 h-5 flex items-center rounded-full transition-all duration-300 ${
          theme ?  "bg-gray-300":"bg-[--color--1]" 
        }`}
      >
        <div
          className={`w-4 h-4 rounded-full shadow-md transform transition-transform duration-300 ${
            theme ?  "translate-x-1 bg-[--color--1]": "translate-x-6 bg-white"
          }`}
        ></div>
      </button>{" "}
    </>
  );
}

export default ThemeToggler;
